<script>
  import { derived } from "svelte/store";
  import { translate } from "../../../../i18n/i18next.js";
  import { getNextTimeShift, useTimezone } from "../../../../hooks/useTimezone.js";
  import InputContainer from "../../../../auto-mps/parts/inputs/InputContainer.svelte";
  import Select from "../../../../auto-mps/parts/inputs/Select.svelte";
  import { getFormattedOffsetDate } from "../../../../utils/time.js";

  /**
   * @type {string}
   */
  export let name

  /**
   * @type {string}
   */
  export let currentProjectTimezone

  /**
   * @type {string}
   */
  export let currentSelectedTimezone

  const {data: timezoneData} = useTimezone()
  const timezones = derived(timezoneData, data => {
    if (!data) return []
    const nowInUnixTime = Date.now() / 1000
    return Object.keys(data).map(key => {
      let current = data[key][0]
      for (let i = 0; i < data[key].length-1; i++) {
        if (nowInUnixTime < data[key][i+1].timestamp) {
          current = data[key][i]
          break
        }
      }
      const offsetString = current.offset >= 0 ? `+${current.offset / 3600}` : `${current.offset / 3600}`
      return {label: `${key} (${current.gen_abb}, UTC${offsetString})`, value: key}
    })
  })

  $: timeShift = getNextTimeShift(currentSelectedTimezone, $timezoneData)
  $: console.log(timeShift)
</script>

<InputContainer>
  <span slot="label">{translate("generic.timezone")}</span>
  <Select name={name}>
    {#each $timezones as timezone}
      <option value={timezone.value} selected={timezone.value === currentProjectTimezone}>{timezone.label}</option>
    {/each}
  </Select>
  <span style="font-size: .9rem" slot="outer">
    {#if timeShift.next}
      {translate("frontend:pages.projects.project.admin.sections.generalInfo.form.timezone.nextTimeShift", null, {at: `${getFormattedOffsetDate(new Date(timeShift.next.timestamp * 1000), "YYYY/MM/DD HH:mm:ss", timeShift.next.offset)} (${timeShift.next.gen_abb})`})}
    {/if}
  </span>
</InputContainer>
